<template>
    <div id="tryout-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout Serial' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h3 class="header-text font-weight-bold">Tryout Serial</h3>
        <!-- end page-header -->
        <v-card>
            <v-card-title>
                Daftar Tryout Serial
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createSerial()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tryout Serial
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="rows"
                :headers="headers"
                :has-action="true"
                :hasOpenNewTab="true"
                v-on:selected="selectedRow = $event"
                :custom-pagination-total-items="rows.length"
                :custom-pagination-current-page="1"
                :custom-pagination-per-page="10"
                v-on:dblClicked="editRow($event)"
                v-on:deleted="
                    dialogConfirm.function = $event;
                    dialogConfirm.title =
                        'Apakah anda yakin akan menghapus tryout serial ini?';
                    dialogConfirm.open = true;
                "
                v-on:openNewTab="openNewTab($event)"
            />
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="deleteSerial(dialogConfirm.function)"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Moment from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "app-serial",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            rows: [],
            headers: [
                { text: "Nama", value: "title", width: 200 },
                { text: "Deskripsi", value: "description", width: 200 },
                { text: "Kelas", value: "grade", width: 100 },
                { text: "Waktu Mulai", value: "openedAt", width: 150 },
                { text: "Waktu Berakhir", value: "closedAt", width: 150 },
                { text: "Aksi", value: "actions", width: 80 },
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    methods: {
        editRow: function (row) {
            this.$router.push({ path: "/serial/form", query: { id: row.id } });
        },

        openNewTab: function (row) {
            let routeData = this.$router.resolve({
                path: "/serial/form",
                query: { id: row.id },
            });

            window.open(routeData.href, "_blank");
        },

        createSerial: function () {
            this.$router.push({ path: "/serial/form" });
        },

        deleteSerial: function (data) {
            var context = this;
            var dataid = data.id;
            this.isLoading = true;

            TryoutService.deleteTryoutSerial(dataid, function (result) {
                if (result.success) {
                    context.dialogConfirm.open = false;
                    context.$store.commit("showAlert", {
                        message: `Data Terhapus!`,
                        type: "success",
                    });
                    context.isLoading = false;
                    context.fetchData();
                    this.$router.push({ path: "/serial" });
                }
            });
        },

        fetchData: function () {
            var context = this;
            this.isLoading = true;
            this.rows = [];

            TryoutService.getListOfTryoutSeries(function (response) {
                if (response.success) {
                    response.data.forEach(function (groupSeries, index) {
                        var openedAt =
                            groupSeries.opened_at != null
                                ? Moment(groupSeries.opened_at).format(
                                      "DD/MM/YYYY, hh:mm:ss",
                                  )
                                : "-";
                        var closedAt =
                            groupSeries.closed_at != null
                                ? Moment(groupSeries.closed_at).format(
                                      "DD/MM/YYYY, hh:mm:ss",
                                  )
                                : "-";
                        var row = {
                            no: index,
                            id: groupSeries.id,
                            title: groupSeries.title,
                            grade: groupSeries.grade,
                            description: groupSeries.description,
                            openedAt: openedAt,
                            closedAt: closedAt,
                        };

                        context.rows.push(row);
                    });

                    context.isLoading = false;
                }
            });
        },
    },

    mounted: function () {
        this.fetchData();
    },
};
</script>



// WEBPACK FOOTER //
// Serial.vue?520d509d